import { Injectable } from "@angular/core";

import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SearchService {
  public search = "";
  public apiData = [];
  public onApiDataChange: BehaviorSubject<any>;
  public onIsBookmarkOpenChange: BehaviorSubject<any>;

  constructor() {
    this.onApiDataChange = new BehaviorSubject("");
    this.onIsBookmarkOpenChange = new BehaviorSubject(false);
  }
}
